export const prospectTitleListKey = () => ["prospect-title-list"];

export const prospectTitleListParamsKey = ({ queryParams }) => [
  ...prospectTitleListKey(),
  queryParams,
];
